/**
 * Playback state
 */
module.exports = {
	ABORT: 'abort',
	CAN_PLAY: 'canPlay',
	CAN_PLAY_THROUGH: 'canPlayThrough',
	DATA_LOADING: 'dataLoading',
	EMPTIED: 'emptied',
	ENDED: 'ended',
	ERROR: 'error',
	LOAD_START: 'loadStart',
	PAUSE: 'pause',
	PLAY: 'play',
	PROGRESS: 'progress',
	STALLED: 'stalled',
	STOP: 'stop',
	SUSPEND: 'suspend',
	TIME_UPDATE: 'timeupdate',
	WAITING: 'waiting',
	PLAY_NOT_ALLOWED: "playbackNotAllowed"
};



//////////////////
// WEBPACK FOOTER
// ./src/base/playback/PlaybackState.js
// module id = 22
// module chunks = 0